import { render, staticRenderFns } from "./DoctorForm.vue?vue&type=template&id=4b11f3ce&"
import script from "./DoctorForm.vue?vue&type=script&lang=js&"
export * from "./DoctorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports